import { ClipboardCheckIcon } from '@/components/icons';
import { FormSection } from '@/components/ui/FormSection';
import type { SatisfactionResponse } from '../types';
import { formatSatisfaction, RATING_LABELS } from '../satisfaction-utils';
import './TimesheetSatisfaction.css';

export const TimesheetSatisfactionResults = ({
  responses,
}: {
  responses: SatisfactionResponse[];
}) => {
  const audiences = ['CONSULTANT'] as const;
  const consultantResponses = responses.filter(
    (entry) => entry.questionnaire.audience === 'CONSULTANT',
  );
  return (
    <FormSection title="Satisfaction de la mission" icon={<ClipboardCheckIcon />}>
      <div className="cra-satisfaction-results">
        {audiences.map((audience) => {
          const response = consultantResponses.find(
            (entry) => entry.questionnaire.audience === audience,
          );
          return (
            <div key={audience} className="cra-satisfaction-result">
              <span>{audience === 'CONSULTANT' ? 'Avis du consultant' : 'Avis interne'}</span>
              <strong>{response ? formatSatisfaction(response.score) : '—'}</strong>
              <small>
                {response
                  ? `${response.questionnaire.stage === 'VALIDATION' ? 'Validation' : 'Soumission'} · ${new Date(response.createdAt).toLocaleDateString('fr-FR')}`
                  : 'Aucun avis recueilli'}
              </small>
            </div>
          );
        })}
      </div>
      {consultantResponses.length > 0 && (
        <div className="cra-satisfaction-history">
          {consultantResponses.map((response) => (
            <details key={response.id}>
              <summary>
                <span>
                  <b>
                    {response.questionnaire.audience === 'CONSULTANT' ? 'Consultant' : 'Interne'} ·{' '}
                    {response.questionnaire.stage === 'VALIDATION' ? 'Validation' : 'Soumission'}
                  </b>
                  <small>
                    {[response.respondent.firstName, response.respondent.lastName]
                      .filter(Boolean)
                      .join(' ') || response.respondent.email}{' '}
                    ·{' '}
                    {new Date(response.createdAt).toLocaleString('fr-FR', {
                      dateStyle: 'short',
                      timeStyle: 'short',
                    })}
                  </small>
                </span>
                <strong>{formatSatisfaction(response.score)}</strong>
              </summary>
              <dl>
                {response.questionnaire.questions.map((question) => {
                  const answer = response.answers[question.id];
                  return (
                    <div key={question.id}>
                      <dt>{question.label}</dt>
                      <dd>
                        {typeof answer === 'number'
                          ? `${answer}/5 · ${RATING_LABELS[answer - 1]}`
                          : answer || 'Non renseigné'}
                      </dd>
                    </div>
                  );
                })}
              </dl>
              <p className="cra-satisfaction-note">
                Questionnaire version {response.questionnaire.version} · Les réponses et le taux
                sont conservés tels qu’enregistrés.
              </p>
            </details>
          ))}
        </div>
      )}
    </FormSection>
  );
};
